import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';

export function RequireAuth({ children }: { children: React.JSX.Element }): React.JSX.Element | null {
    const { user, loading } = useContext(UserContext);

    if (loading) {
        return null;
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
